const methods = {
  show() { this.$refs.modal.show(); },
  hide() { this.$refs.modal.hide(); },
  toggle() { this.$refs.modal.toggle(); },
};

export default {
  methods,
};
